function LoadView(view) {
  return () =>
    import(
      /* webpackChunkName: "view-[request]" */ `@/html/subpage/unpaid/${view}.vue`
    );
}

const unpaidRoutes = [
  // 미납요금 - 안내
  {
    path: '/unpaidinfo',
    name: 'unpaidinfo',
    component: LoadView('unpaidInfo'),
    meta: {
      category: ['미납요금', '미납요금 안내'],
    },
  },
  // 미납주차요금 - 조회/결제
  {
    path: '/unpaidsearch',
    name: 'unpaidsearch',
    component: LoadView('unpaidSearch'),
    meta: {
      category: ['미납요금', '미납요금 조회/결제'],
    },
  },
];

export default unpaidRoutes;
